module.exports = __webpack_public_path__ + "img/crew_upgrade2_7-7-2021.9cf6a4bc.jpg";